import script from "./TechnicianChipRow.vue?vue&type=script&setup=true&lang=js"
export * from "./TechnicianChipRow.vue?vue&type=script&setup=true&lang=js"

import "./TechnicianChipRow.vue?vue&type=style&index=0&id=0b56ac00&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b56ac00"]])

export default __exports__